import { FC } from "react";
import { Redirect, Route, RouteProps } from "react-router";

import { useAuth } from "src/contexts/AuthContext";

export const ProtectedRoute: FC<RouteProps> = props => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? <Route {...props} /> : <Redirect to="/sign-in" />;
};
